<template>
  <div class="MainLayout">
    <div id="pre-header-slot" />

    <AppHeader />
    <main class="PageContainer u-container">
      <slot name="banner" />
      <slot />
    </main>
  </div>
</template>
